import HBIcon from "@/components/HBIcon";
import { isEnter } from "@/utils/keyBoard";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import classNames from "classnames";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styles from "./index.module.less";

/**
 * 搜索输入框
 * @param {{
 *   onSearch?: function,
 *   hideSearchBtn?: boolean,
 *   preTags?: Array,
 *   wrapClassName?: string,
 * } & import("antd").InputProps} props 和antd的Input属性一致
 * @returns {JSX.Element}
 */
function HBSearchInput(
  { hideSearchBtn = false, onSearch, wrapClassName, ...props } = {},
  ref
) {
  const [isFocus, setFocus] = useState(false);

  const [isFilled, setFilled] = useState(false);

  // 当前拼音输入的参数
  const [pinyininput, setPinyin] = useState(false);

  const inputRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      input: inputRef.current.input,
    }),
    [inputRef]
  );

  useEffect(() => {
    if (props.value) {
      setFilled(true);
    } else {
      setFilled(false);
    }
  }, [props.value]);

  const prefix = <HBIcon className={styles.searchIcon} type="ic_search" />;
  const suffix = hideSearchBtn ? null : (
    <Button
      className={styles.btn}
      type="primary"
      onClick={(e) => {
        inputRef.current.input.blur();
        onSearch && onSearch(inputRef.current.input.value);
        e.stopPropagation();
      }}
    >
      <SearchOutlined />
    </Button>
  );

  return (
    <div
      className={classNames(styles.wrap, wrapClassName, {
        [styles.filled]: isFilled,
        [styles.focus]: isFocus,
      })}
      style={props.style || {}}
    >
      <Input
        allowClear
        ref={inputRef}
        prefix={prefix}
        suffix={suffix}
        {...props}
        className={classNames(
          styles.search,
          {
            [styles.hasSearchBtn]: !hideSearchBtn,
          },
          props.className
        )}
        // autoComplete="off"
        onFocus={(e) => {
          setFocus(true);
          props.onFocus && props.onFocus(e);
        }}
        onBlur={(e) => {
          setFocus(false);
          if (e.target.value) {
            setFilled(true);
          } else {
            setFilled(false);
          }
          props.onBlur && props.onBlur(e);
        }}
        onKeyDown={(e) => {
          if (isEnter(e) && !pinyininput) {
            onSearch && onSearch(e.target.value);
            e.target.blur();
          }
          props.onKeyDown && props.onKeyDown(e);
        }}
        onInput={(e) => {
          if (e.target.value) {
            setFilled(true);
          } else {
            setFilled(false);
          }
          props.onInput && props.onInput(e);
        }}
        onCompositionStart={() => setPinyin(true)}
        onCompositionEnd={() =>
          // 没有异步在火狐浏览器里无法输入中文
          setTimeout(() => {
            setPinyin(false);
          }, 1)
        }
      />
    </div>
  );
}

export default forwardRef(HBSearchInput);
